import { combineReducers } from 'redux';
import { connectRouter, RouterState } from 'connected-react-router';
import { History } from 'history';

import app, { IAppState } from './app';
import user, { IUserState } from './user';
import messages, { IMessagesState } from './messages';
import filters, { IFilterState } from './vehicleFilters';
import notification, { INotificationState } from './notification';
import map, { IMapState } from './map';
import settings, { ISettingsState } from './settings';
import journalFilters, { IJournalFilters } from './journalFilters';
import { adas, IAdasState } from './adas';

export interface IRootState {
  app: IAppState;
  user: IUserState;
  messages: IMessagesState;
  filters: IFilterState;
  router: RouterState;
  notification: INotificationState;
  map: IMapState;
  settings: ISettingsState;
  journalFilters: IJournalFilters;
  adas: IAdasState;
}

export default (history: History) =>
  combineReducers({
    app,
    user,
    messages,
    filters,
    notification,
    map,
    settings,
    journalFilters,
    adas,
    router: connectRouter(history),
  });
